const initialState: any = '';

interface ReduxProps {
  type: string;
  value: string;
}

export default (state = initialState, { type, value }: ReduxProps): string => {
  switch (type) {
    case 'SET_CLIENT':
      return value;
    default:
      return state;
  }
};
